/**
 * MIRA — global auth context.
 * Provides { user, loading, refresh, signOut } to every MIRA page.
 */
import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import mira from './api';

const Ctx = createContext({ user: null, loading: true, refresh: () => {}, signOut: () => {} });

export const MiraAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!localStorage.getItem('mira_token')) {
      setUser(null); setLoading(false); return null;
    }
    try {
      const { data } = await mira.get('/auth/me');
      setUser(data.user);
      return data.user;
    } catch {
      setUser(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  const signOut = useCallback(() => {
    localStorage.removeItem('mira_token');
    setUser(null);
    window.location.href = '/mira/login';
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return <Ctx.Provider value={{ user, loading, refresh, signOut }}>{children}</Ctx.Provider>;
};

export const useMiraAuth = () => useContext(Ctx);
